module cr.events
{
    class selectEventCtrl {
        static $inject = ['$scope', '$q', '$element', '$timeout', '$state', 'eventService', '$modal', "$log",'notificationService'];
        public $type: string = "";

        public ExpandedNodes:any = {};

        public searchResult:any;
        public errorMessage: string;

        DebouncedSearchContact:any;
        SearchDefer:any;

     /*   SelectContactDetail (contactId?) {
            contactId = (angular.isDefined(contactId)) ? contactId : this.$scope.selectedContact.Id;
            var ctrl = this;


            var modal = this.$modal.open({
                scope: ctrl.$scope,
                templateUrl: 'modules/event/views/contactdetail.html',
                resolve: {
                    //contactDetail: () => (contactId !== 0) ? ctrl.contactService.GetContactDetails(contactId) : null,
                    selectedEvent: () => angular.copy(ctrl.$scope.selectedEvent)

                },
                controller: 'contactDetailCtrl',
                controllerAs: 'contactDetailCtrl',
                show: true
            });

            modal.result.then(
                (resp:any)=> {
                    ctrl.$scope.selectedContact = resp;

                    //ctrl.ClearSearch();
                    //this.notificationService.addNotification(cr.infrastructure.notification.notificationType.Success, message, this.$scope);
                });
        }*/

        ClearEvent=()=>{
            this.notificationService.showMessage("#CONFIRMCLEAR","#CONFIRM","YES|*NO",this.$scope).then(button=> {
                if (button == "YES") {
                    this.SetEvent(null);
                }
            });
        }

        SetEvent=(event)=>{
            if (angular.isDefined(this.$scope.selectEvent)){
                console.log("call custom function");
                this.$scope.selectEvent({ event: event });
            }
            else {
                console.log("set scope directly");
                this.$scope.eventView=event;
            }
            console.log("event selection: "+angular.toJson(event));
        }

        SelectEvent($event?) {
            console.log("select event clicked");
            this.eventService.selectEvent().then(data=> {
                //40|if| |(|scope|.|rowAction|)| |scope|.|rowAction|(|{|action|:| |{|action|:|action|,|data|:|data|}|}|)|;
                console.log("select event: "+angular.toJson(this.$scope.selectEvent));

                this.SetEvent(data);
            },error=>{
                console.log("error: "+angular.toJson(error));
            });
          /*  console.log("search contacts");

            // prevent Blur event on input from coming through
            if ($event) $event.preventDefault();
            this.$timeout(() => this.$element.find('input#select-contact-search-field')[0].focus());

            // reject previous defers, so they don't come in later
            if (this.SearchDefer) this.SearchDefer.reject();

            // store defer
            if( this.searchOn === "VAT" ) {
                this.SearchDefer = this.contactService.SearchContactsByVAT(toSearch, this.manufacturerId);
            } else {
                this.SearchDefer = this.contactService.SearchContacts(toSearch, this.manufacturerId);
            }

            // handle promise of defer
            this.SearchDefer.promise.then(searchResult => this.searchResult = searchResult);*/
        }

        RemoveSelectedContact() {
            this.$scope.selectedEvent = null;

            // select input field
            //this.$timeout(() => this.$element.find('input#select-contact-search-field')[0].focus());
        }


        constructor( private $scope:any, private $q: angular.IQService, private $element: angular.IRootElementService,
                     private $timeout: angular.ITimeoutService, private $state: angular.ui.IState, private eventService,
                     private $modal: angular.ui.bootstrap.IModalService, private $log: angular.ILogService, private notificationService ) {

            $scope.context = "event";
            $scope.selectedContact = $scope.selectedContact || null;


            this.$scope.search = '';


           /* if( ! this.manufacturerId ) {
                this.errorMessage = "NO MANUFACTURER DEFINED FOR THIS DIRECTIVE"
                this.$log.error( "No manufacturer defined for select contact control." );
            }*/

        }
    }

    class selectEventDirective
    {
        restrict = 'E';
        replace = true;

        scope = {
            eventView: '=',
            selectEvent: '&',
        };

        templateUrl = "modules/event/views/eventview.html";

        controller = selectEventCtrl;
        controllerAs = 'selectEventCtrl';

        $scope:any;
        element:any;

        constructor( ) {
            console.log("select event directive instanciated");
        }
    }

    eventModule.directive('crSelectEvent', () => new selectEventDirective( ) );
}
